/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */

import { ofType } from 'redux-observable';
import { interval, Observable } from 'rxjs';
import { debounce, map } from 'rxjs/operators';

import { ActionManagerInstance } from '../actions/manager';
import constants from '../constants';
import { getResolvedTargetName } from '../router/routing-manager';
import PubSubUtils from '../utils/pubsub-utils';
import * as actionType from '../store/state/actions';
import * as actions from '../store/state/actions/action-creators';
import * as StateManager from '../store/state/state-manager';
import type { Action } from '../store/state/state-manager';

export const showCreateStageCancelAlert = (action$: Observable<Action>) => {
  return action$.pipe(
    ofType(actionType.SHOW_CANCEL_ALERT),
    /*
      Debounce to give opportunity to return the promise back from the actions API.
      Without debounce Cancel button stays in disable state when the cancel alert is opened and never gets enabled.
    */
    debounce(() => interval(100)),
    map((action: Action) => {
      const {
        actionMgrID,
        isChildCase,
        isModalAction,
        isProcessAction,
        isDataObject,
        skipReleaseLockRequest,
        isInCreateStage,
        containerItemID,
        context
      } = action.payload;
      ActionManagerInstance.resolveActionByID(actionMgrID);
      PubSubUtils.publish(constants.PUB_SUB_EVENTS.EVENT_SHOW_CANCEL_ALERT, {
        isModalAction,
        hideDelete: isProcessAction ? false : isChildCase,
        isDataObject,
        skipReleaseLockRequest,
        isInCreateStage,
        containerItemID: context || containerItemID
      });
      return [];
    })
  );
};

export const activateModalContainerItem = (action$: Observable<Action>) => {
  return action$.pipe(
    ofType(actionType.ACTIVATE_MODAL_CONTAINER_ITEM),
    /*
      Debounce to give opportunity to return the promise back from the actions API.
      Without debounce Cancel button stays in disable state when the cancel alert is opened and never gets enabled.
    */
    debounce(() => interval(100)),
    map((action: Action) => {
      const { actionMgrID, context, containerName, containerItemID } = action.payload;
      const target = getResolvedTargetName(containerName, context);
      ActionManagerInstance.resolveActionByID(actionMgrID);
      StateManager.dispatch(
        actions.postProcess(actions.activateContainerItem, {
          containerItemID,
          target,
          doDeleteCaseSummary: false
        })
      );
      return [];
    })
  );
};
